import PropTypes from 'prop-types';
import {ArticleText, Paragraph} from './styles';

const ArticleParagraph = ({text}) => (
  <ArticleText>
    {/* <h3>{title}</h3> */}
    <Paragraph
      className="paragraph"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  </ArticleText>
);

ArticleParagraph.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ArticleParagraph;
